import * as React from 'react';
import { MenuItemBadge as MenuItemBadgeType } from 'moduleBase/types/Menu';
import { FC } from 'react';

type PropsType = {
  badge: MenuItemBadgeType,
}

const MenuItemBadge: FC<PropsType> = ({ badge }) => {
  if (!badge) {
    return null;
  }

  return (
    <span className={`badge badge-${badge.style} badge-pill d-inline-flex ml-4p`}>
      <span className="indicator text-white mr-4p" />
      {badge.label}
    </span>
  );
};

export { MenuItemBadge };
